
import mediclubProductLoader from '~/helpers/mediclub3productLoader'
import keepAliveScrollMixin from '~/mixins/keepAliveScroll'

export default {
  // eslint-disable-next-line vue/match-component-file-name
  name: 'MediclubPage',

  mixins: [
    keepAliveScrollMixin,
  ],

  middleware: [
    ({ route, error, app }) => {
      const availablePages = [
        'aktywnosc-fizyczna',
        'dla-dzieci',
        'leczenie',
        'macierzynstwo',
        'odzywianie',
        'profilaktyka',
        'wyglad',
        'zdrowie-psychiczne',
      ]

      if (!availablePages.includes(route.params.page)) {
        return error({
          statusCode: 404,
          message: app.i18n.t('Page not found'),
        })
      }
    },
  ],

  async asyncData ({ app, store, route }) {
    const page = route.params.page
    const pageBlockKey = `mediclub-block-v3-construction-${page}`

    await store.dispatch('staticBlock/getByIdentifiers', [
      pageBlockKey,
      `mediclub-block-v3-${page}-hero`,
      `mediclub-block-v3-${page}-value-proposition`,
      `mediclub-block-v3-${page}-2`,
      `mediclub-block-v3-${page}-3`,
      'mediclub-block-v3-pages-cards',
      `mediclub-block-v3-${page}-survey`,
      `mediclub-block-v3-${page}-5`,
      `mediclub-block-v3-${page}-7`,
      `mediclub-block-v3-${page}-8`,
      `mediclub-block-v3-${page}-9`,
      'mediclub-block-v3-10',
      'mediclub-block-v3-faq',
      'mediclub-block-v3-pages-menu',
    ])

    const blocks = store.getters['staticBlock/GET_BLOCKS'](pageBlockKey)
    const isReady = blocks?.[pageBlockKey]?.contentJson?.isReady || false
    const breadcrumb = blocks?.[pageBlockKey]?.contentJson?.breadcrumb || page

    const { limitedBenefitItems, activeIndex } = await mediclubProductLoader({ app, store }, `mediclub-block-v3-${page}-5`)

    store.dispatch('breadcrumbs/setBreadcrumbs', {
      breadcrumbs: [{
        categoryName: 'MediClub',
        categoryUrlPath: 'mediclub',
      }],
      name: breadcrumb,
      startPath: '',
    })

    return {
      page,
      pageBlockKey,
      isReady,
      activeIndex,
      limitedBenefitItems,
    }
  },

  methods: {
    getPageColorVariables () {
      const blockData = this.$store.getters['staticBlock/GET_BLOCKS'](this.pageBlockKey)
      const content = blockData?.[this.pageBlockKey]?.contentJson ?? {}

      const variables = {
        main: content.color || '#115585',
        bgColor: content.bgColor || '#4882a1',
        gradient1: content.gradient1 || 'rgba(7, 119, 186, 0.9)',
        gradient2: content.gradient2 || 'rgba(0, 73, 149, 0.9)',
        lineQest: content.lineQest || '#3284b3',
        text: content.text || '#ffffff',
      }

      return Object.entries(variables).map(([v, k]) => `--color-${v}: ${k};`).join('')
    },
  },
}
